import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    path: String,
    props: Object,
  };

  root = null;
  _rendering = false;

  async connect() {
    if (!this.hasPathValue) return;
    await this.renderReact();
  }

  async renderReact() {
    if (this.root || this._rendering) return;

    this._rendering = true;

    try {
      const [{ createElement }, { createRoot }, module] = await Promise.all([
        import("react"),
        import("react-dom/client"),
        import(
          /* webpackInclude: /\.(js|jsx)$/ */ `../../../${this.pathValue}`
        ),
      ]);

      if (!this._rendering) return;

      const Component = module.default;

      this.root = createRoot(this.element);
      this.root.render(createElement(Component, this.propsValue || {}));
    } catch (e) {
      console.error("React Component Render Error:", e);
    } finally {
      this._rendering = false;
    }
  }

  disconnect() {
    this._rendering = false;
    if (this.root) {
      this.root.unmount();
      this.root = null;
    }
  }
}
